import React from 'react';
import PropTypes from 'prop-types';
import {utils, writeFile} from 'xlsx';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {isEmpty, extractWorkSheetData, formatDate, ExcelDateToDateString} from "../../globals/GlobalFunctions";

export interface Props {
    excelData: any;
}

//pipe delimited
function DisclosedRXFormatter ({excelData}: Props) {
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    try{
        //Check for 2 sheets here
        if (!isEmpty(excelData) && excelData.Sheets.DRX !== undefined) {
            let sheetDataArray = extractWorkSheetData(excelData.Sheets.DRX);

            let rawCellArray: any[] = sheetDataArray[0];

            let columnRange: number = sheetDataArray[1];

            let rowRange: number = sheetDataArray[2];

            const valuesIndexCollection = {
                memberSegIndex: rawCellArray.indexOf('Member Sequence') + 1,
                //subscriberSSNIndex: rawCellArray.indexOf('Subscriber SSN') + 1,
                altIDIndex: rawCellArray.indexOf('Member Alternate ID') + 1,
                fnIndex: rawCellArray.indexOf('Member First Name') + 1,
                mnIndex: rawCellArray.indexOf('Member Middle Name') + 1,
                lnIndex: rawCellArray.indexOf('Member Last Name') + 1,
                divisionIndex: rawCellArray.indexOf('Division ID') + 1,
                dobIndex: rawCellArray.indexOf('Member Date of Birth') + 1,
                subscriberIndex: rawCellArray.indexOf('Subscriber ID') + 1,
                phoneIndex: rawCellArray.indexOf('Member Home Phone') + 1,
                enrollDateIndex: rawCellArray.indexOf('Effective Date') + 1,
                disenrollDateIndex: rawCellArray.indexOf('Termination Date') + 1,
                groupIndex: rawCellArray.indexOf('Group ID') + 1,
                tierIndex: rawCellArray.indexOf('Tier') + 1,
                sexIndex: rawCellArray.indexOf('Member Gender') + 1,
                memberSSNIndex: rawCellArray.indexOf('Member SSN') + 1,
                addIndex: rawCellArray.indexOf('Member Address') + 1,
                add2Index: rawCellArray.indexOf('Member Address 2') + 1,
                cityIndex: rawCellArray.indexOf('Member City') + 1,
                stateIndex: rawCellArray.indexOf('Member State') + 1,
                zipIndex: rawCellArray.indexOf('Member Zip Code') + 1,
                emailIndex: rawCellArray.indexOf('Member Email Address') + 1,
                planIDIndex: rawCellArray.indexOf('Plan ID') + 1,
                //relationshipTypeIndex: rawCellArray.indexOf('Relationship Type') + 1,
            }

            let arrayOfMemberArrays: any[] = [[
                "Carrier|Group #|DRX Group #|Cardholder Num|Person Code|Effective Date|Term Date|Coverage Code|DOB|Last Name|First Name|Middle Initial|Gender|SSN|" +
                "Division|Address 1|Address 2|City|State|ZIP|Home Phone|Work Phone|Email Address|Relationship Code|Old Patient Number|Filler|"
            ]];

            for (let i = 1; i < rowRange; i++) {
                //our member to later be pushed. Oh from what humble origins it begins
                let memberArray: any[] = [];
                let memberString: string = "";
                //for each new member array we skip over the previous members determined by the column length, removing 1 to account for our zero based index at the beginning
                let rowMultiplier = columnRange * i - 1;

                //exclude terms
                let today = new Date();

                let termDate = new Date(Math.round((rawCellArray[(rowMultiplier + valuesIndexCollection.disenrollDateIndex)] - 25568)*86400*1000));

                if (termDate > today) {

                    //client code to start here
                    memberString += "DRX|";

                    if (valuesIndexCollection.groupIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.groupIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    //DisclosedRX group IDs are based on plans
                    if (valuesIndexCollection.planIDIndex > 0) {
                        if(rawCellArray[(rowMultiplier + valuesIndexCollection.planIDIndex)].toString() === "BIDP"){
                            memberString += "3018A|"
                        }
                        else if (rawCellArray[(rowMultiplier + valuesIndexCollection.planIDIndex)].toString() === "BIOA"){
                            memberString += "3018B|"
                        }
                        else{
                            memberString += "|"
                        }
                    } else {
                        memberString += "|";
                    }

                    //the subscriber ID with 01 if no alt
                    if (valuesIndexCollection.altIDIndex > 0) {
                        if (rawCellArray[(rowMultiplier + valuesIndexCollection.altIDIndex)].toString().length > 0) {
                            memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.altIDIndex)].toString() + "|");
                        } else if (valuesIndexCollection.subscriberIndex > 0 && rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberIndex)].toString().length > 0) {
                            memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberIndex)].toString() + "01|");
                        } else {
                            memberString += "|";
                        }
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.memberSegIndex > 0) {
                        memberString += "0" + (rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    //date format, moves 2024 dates to 2025
                    if (valuesIndexCollection.enrollDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.enrollDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.substring(0,4) === "2024") {
                            memberString += "20250101|";
                        }
                        else {
                            memberString += (date + "|");
                        }
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.disenrollDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.disenrollDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date === "117974" || date === "22221231") {
                            date = "";
                        }
                        memberString += (date + "|");
                    } else {
                        memberString += "|";
                    }

                    //individual or family
                    if (valuesIndexCollection.tierIndex > 0) {
                        if(rawCellArray[(rowMultiplier + valuesIndexCollection.tierIndex)].toString() === "EM"){
                            memberString += "I|";
                        }
                        else if(rawCellArray[(rowMultiplier + valuesIndexCollection.tierIndex)].toString() === "ES"){
                            memberString += "F|";
                        }
                        else if(rawCellArray[(rowMultiplier + valuesIndexCollection.tierIndex)].toString() === "EC"){
                            memberString += "F|";
                        }
                        else if(rawCellArray[(rowMultiplier + valuesIndexCollection.tierIndex)].toString() === "FA"){
                            memberString += "F|";
                        }
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.dobIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.dobIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        memberString += (date + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.lnIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.lnIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.fnIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.fnIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.mnIndex > 0 && rawCellArray[(rowMultiplier + valuesIndexCollection.mnIndex)].toString().length > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.mnIndex)].toString().substring(0,1) + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.sexIndex > 0) {
                        let sex = rawCellArray[(rowMultiplier + valuesIndexCollection.sexIndex)].toUpperCase();
                        if(sex === "MALE"){
                            sex = "M";
                        }
                        else if(sex === "FEMALE"){
                            sex = "F";
                        }
                        else if(sex === "UNDEFINED"){
                            sex = "U";
                        }
                        memberString += (sex + "|");
                    }
                    else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.memberSSNIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.memberSSNIndex)].toString().toUpperCase() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.divisionIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.divisionIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.addIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.addIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.add2Index > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.add2Index)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.cityIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.cityIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.stateIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.stateIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.zipIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.zipIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.phoneIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.phoneIndex)].toString() + "|");
                    } else {
                        memberString += "|";
                    }

                    memberString += "|";

                    if (valuesIndexCollection.emailIndex > 0) {
                        memberString += (rawCellArray[(rowMultiplier + valuesIndexCollection.emailIndex)].toString().toUpperCase() + "|");
                    } else {
                        memberString += "|";
                    }

                    if (valuesIndexCollection.memberSegIndex > 0) {
                        if(rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString() === "01"){
                            memberString += "1|"
                        }
                        else if(rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString() === "02"){
                            memberString += "2|"
                        }
                        else {
                            memberString += "3|";
                        }
                    } else {
                        memberString += "|";
                    }

                    memberString += "||";

                    memberArray.push(memberString);

                    arrayOfMemberArrays.push(memberArray);
                }
            }

            //create our workbook
            const eligWorkbook = utils.book_new();
            //make the member sheet from our member array of arrays
            let ws1 = utils.aoa_to_sheet(arrayOfMemberArrays, {dateNF: 'mm.dd.yyyy'});

            const today = new Date();

            const month = today.getMonth() + 1;

            let monthString = "";

            let dayString = "";

            if(month < 10){
                monthString = "0" + month.toString();
            }
            else{
                monthString = month.toString();
            }

            const day = today.getDate();

            if(day < 10) {
                dayString = "0" + day.toString();
            }
            else {
                dayString = day.toString();
            }

            const year = today.getFullYear();

            //add it to the new workbook
            utils.book_append_sheet(eligWorkbook, ws1, "DisclosedRX" + year + monthString + dayString );
            //it exists and has a sheet send it back to app for export
            if (eligWorkbook && eligWorkbook.SheetNames.includes("DisclosedRX" + year + monthString + dayString )) {
                if (!eligWorkbook.Props) eligWorkbook.Props = {};

                //setting the workbook title through props
                eligWorkbook.Props.Title = "CAS_" + year + monthString + dayString + ".txt";

                //writing the file which will make the download, second param is the name of the file and third is required options
                writeFile(eligWorkbook, "CAS_" + year + monthString + dayString + ".txt", {});

                console.log("File Export Complete!");
                setSuccessAlert(true);
            } else {
                setErrorAlert(true);
                console.log("Unknown Export Error!");
            }

            //clear it out at the end in case of rerendering
            excelData.Sheets.DRX = undefined;
        }
    }
    catch(e) {
        console.log("ERROR", e);

        setErrorAlert(true);
        //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
        excelData.Sheets.DRX = undefined;

    }
    return (
        <div>
            {successAlert ? <Alert severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                File Download Complete!
            </Alert> : <></> }
            {errorAlert ? <Alert severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                <AlertTitle>Error!</AlertTitle>
                There was an error with this file!
            </Alert> : <></> }
        </div>
    );
}


export default React.memo(DisclosedRXFormatter)

DisclosedRXFormatter.propTypes = {
    excelData: PropTypes.object.isRequired,
};